import Bugsnag, { Client } from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { EnvironmentVariables, getEnvironmentVariable } from '@Services/env/environment.service';
import { useBoundStore } from '@Store/useBoundStore';

export let bugsnagClient: Client;

export const ObservabilityInit = () => {
  const getCustomerData = useBoundStore.getState().getCustomerData;
  bugsnagClient = Bugsnag.start({
    apiKey: getEnvironmentVariable(EnvironmentVariables.VITE_APP_BUG_SNAG),
    plugins: [new BugsnagPluginReact()],
    onError: function (event) {
      const customer = getCustomerData();
      event.setUser(
        customer.customerId,
        customer.customerData.email,
        customer.customerData.firstName
      );
    },
  });
};

export const reportError = (error: IObservabilityError) => {
  if (!bugsnagClient) {
    console.error('Bugsnag client is not initialized');
    return;
  }
  const getCustomerData = useBoundStore.getState().getCustomerData;
  const customer = getCustomerData();

  bugsnagClient.notify(error.metadata.name, (event) => {
    event.setUser(
      customer.customerId,
      customer.customerData.email,
      customer.customerData.firstName
    );
    const severityMap: { [key in ObservabilityErrorSeverity]: 'info' | 'warning' | 'error' } = {
      [ObservabilityErrorSeverity.INFO]: 'info',
      [ObservabilityErrorSeverity.WARNING]: 'warning',
      [ObservabilityErrorSeverity.ERROR]: 'error',
    };
    event.severity = severityMap[error.severity];
  });
};

export interface IObservabilityError {
  metadata: {
    name: string;
    message: string;
  };
  severity: ObservabilityErrorSeverity;
}

export enum ObservabilityErrorSeverity {
  INFO,
  WARNING,
  ERROR,
}
